import https from "./https"
import store from "@/store"

const organization = store.state.general.organization;

const checkin_missions = {
  // 簽到任務
  getCheckinMissions(params) {
    return https.get(
      `admin/organizations/${organization.id}/checkin-missions`, 
      { params }
    );
  },

  // 簽到任務創建
  createCheckinMission(params) {
    return https.post(
      `admin/organizations/${organization.id}/checkin-missions`, 
      params
    );
  },

  getCheckinMission(id) {
    return https.get(`admin/organizations/${organization.id}/checkin-missions/${id}`);
  },

  updateCheckinMission(id, params) {
    return https.put(`admin/organizations/${organization.id}/checkin-missions/${id}`, params);
  },

  deleteCheckinMission(id) {
    return https.delete(`admin/organizations/${organization.id}/checkin-missions/${id}`);
  },
}

export default checkin_missions
